// src/axiosInstance.js
import axios from "axios";

// Event to notify about unauthorized access
const unauthorizedEvent = new Event("unauthorized");
const forbiddenEvent = new Event("forbidden");
const expiredEvent = new Event("tokenExpired");

// Create an Axios instance
const axiosInstance = axios.create({});

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // You can modify the response here
    return response;
  },
  (error) => {
    // Handle response errors
    if (error.response && error.response.status === 401) {
      window.dispatchEvent(unauthorizedEvent);
    }

    if (error.response && error.response.status === 403) {
      window.dispatchEvent(forbiddenEvent);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
